<template>
<div :style="styles">
  <vue-speedometer
    :needleHeightRatio="0.7"
    :maxSegmentLabels="0"
    :segments="1000"
    :value="val"
    :fluidWidth="true"
    :minValue="0"
    :maxValue="100"
    currentValueText=""
    needleHeightRatio="0.5"
    needleColor="#310842"
    startColor="#e31f21"
    endColor="#00ce47"
    :needleTransitionDuration="needleduration"
    valueTextFontSize="20px"
    textColor="#212529"
    
    ringWidth="28"
  />
</div>
</template>
<script>
import VueSpeedometer from "vue-speedometer"
export default {
  components: { VueSpeedometer },

        props: [
            'value',
            'needlespeed'
        ],

   data() {
    return {
      styles: {
        width: "240px",
        height: "140px",
        background: "#ffffff",
        position: 'absolute',
        top: '-15px',
        left: '-25px'
      },
      val: Number(this.value),
      needleduration: Number(this.needlespeed)
    }
  },
}

</script>